"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _bind2 = _interopRequireDefault(require("classnames/bind"));

var _constants = require("../utils/constants");

var _FormMessage = _interopRequireDefault(require("./_FormMessage"));

var _Popper = _interopRequireDefault(require("../utils/_Popper"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _withStyles = _interopRequireDefault(require("../utils/withStyles"));

var _react = _interopRequireWildcard(require("react"));

var _popover = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/popover.css") : void 0);

var classnames = (0, _bind.default)(_bind2.default).call(_bind2.default, _popover.default);

var FormValidationOverlay = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var _validationState$text;

  var className = _ref.className,
      cssNamespace = _ref.cssNamespace,
      control = _ref.control,
      formMessageProps = _ref.formMessageProps,
      innerRefClassName = _ref.innerRefClassName,
      popperClassName = _ref.popperClassName,
      popperProps = _ref.popperProps,
      referenceClassName = _ref.referenceClassName,
      show = _ref.show,
      validationState = _ref.validationState,
      wrapperProps = _ref.wrapperProps,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["className", "cssNamespace", "control", "formMessageProps", "innerRefClassName", "popperClassName", "popperProps", "referenceClassName", "show", "validationState", "wrapperProps"]);

  var _useState = (0, _react.useState)(show),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      showValidationMessage = _useState2[0],
      setShowValidationMessage = _useState2[1];

  var _handleBlur = function _handleBlur() {
    setShowValidationMessage(false);
  };

  var _handleFocus = function _handleFocus() {
    setShowValidationMessage(true);
  };

  var popoverClasses = classnames("".concat(cssNamespace, "-popover"), className);
  var referenceClasses = classnames("".concat(cssNamespace, "-popover__control"), referenceClassName);

  var bodyContent = /*#__PURE__*/_react.default.createElement(_FormMessage.default, (0, _extends2.default)({}, formMessageProps, {
    type: validationState === null || validationState === void 0 ? void 0 : validationState.state
  }), validationState === null || validationState === void 0 ? void 0 : validationState.text);

  var referenceComponent = /*#__PURE__*/_react.default.cloneElement(control, rest);

  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, wrapperProps, {
    className: popoverClasses,
    onBlur: _handleBlur,
    onFocus: _handleFocus,
    ref: ref
  }), /*#__PURE__*/_react.default.createElement(_Popper.default, {
    cssBlock: "".concat(cssNamespace, "-popover"),
    innerRefClassName: innerRefClassName,
    noArrow: true,
    popperClassName: popperClassName,
    popperPlacement: 'bottom-start',
    popperProps: popperProps,
    referenceClassName: referenceClasses,
    referenceComponent: referenceComponent,
    show: showValidationMessage && (validationState === null || validationState === void 0 ? void 0 : (_validationState$text = validationState.text) === null || _validationState$text === void 0 ? void 0 : _validationState$text.length) > 0,
    usePortal: true
  }, bodyContent));
});

FormValidationOverlay.displayName = 'FormValidationOverlay';
process.env.NODE_ENV !== "production" ? FormValidationOverlay.propTypes = {
  /** CSS class(es) to add to the outer wrapping div */
  className: _propTypes.default.string,
  control: _propTypes.default.node,

  /** Additional props to be spread to the FormMessage component */
  formMessageProps: _propTypes.default.object,

  /** CSS class(es) to add to the popper's child `<div>` wrapping the provided children */
  innerRefClassName: _propTypes.default.string,

  /** CSS class(es) to add to popper's outermost wrapping `<div>` element */
  popperClassName: _propTypes.default.string,

  /** Additional props to be spread to the overlay element, supported by <a href="https://popper.js.org" target="_blank">popper.js</a> */
  popperProps: _propTypes.default.object,

  /** CSS class(es) to add to the reference div */
  referenceClassName: _propTypes.default.string,

  /** Set to **true** to default ValidationOverlay to an open state */
  show: _propTypes.default.bool,

  /** An object identifying a validation message.  The object will include properties for `state` and `text`; _e.g._, \`{ state: \'warning\', text: \'This is your last warning\' }\` */
  validationState: _propTypes.default.shape({
    /** State of validation: 'error', 'warning', 'information', 'success' */
    state: _propTypes.default.oneOf(_constants.FORM_MESSAGE_TYPES),

    /** Text of the validation message */
    text: _propTypes.default.string
  }),

  /** Additional props to be spread to the wrapping `<div>` element */
  wrapperProps: _propTypes.default.object
} : void 0;
FormValidationOverlay.defaultProps = {
  popperProps: {}
};

var _default = (0, _withStyles.default)(FormValidationOverlay);

exports.default = _default;